import React from 'react'
import { css } from '@emotion/react'
import { useSelector } from 'react-redux'

import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import Scroller from 'components/Scroller'
import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import TrialSetupMessageCard from 'components/TrialSetup/MessageCard'
import TicketList from 'subapps/ticketing/components/TicketList'
import { selectShowAddMailboxMessageCard } from 'selectors/trial_setup'
import ActionBar from './ActionBar'
import SearchBar from './SearchBar'

// Wraps the ticket list container and adds mouseEnter/Leave events
export default function TicketListPane({
  hasSearchErrored,
  isQueryStringValid,
  listTitle,
  queryString,
  ticketIds,
}) {
  const showTrialMessage = useSelector(selectShowAddMailboxMessageCard)

  return (
    <div
      css={css`
        height: 100%;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background-color: white;
      `}
    >
      <SearchBar ticketIds={ticketIds} listTitle={listTitle} />

      {showTrialMessage && <TrialSetupMessageCard />}

      <ActionBar ticketIds={ticketIds} listTitle={listTitle} />

      {queryString && hasSearchErrored && <SearchErrorMessage />}

      {queryString &&
        !isQueryStringValid &&
        !hasSearchErrored && (
          <Scroller className="desktopNormalScrollbarDisableRightBorder">
            <InvalidSearchMessage queryString={queryString} />
          </Scroller>
        )}
      {(!queryString || (!hasSearchErrored && isQueryStringValid)) && (
        <TicketList is3ColumnView isSidebarOpen />
      )}
    </div>
  )
}
